var map = {
	"./avbryt_button_controller.js": 8109,
	"./charbox_size_controller.js": 2929,
	"./currentword_size_controller.js": 5597,
	"./fish_controller.js": 5910,
	"./game_controller.js": 6964,
	"./game_input_controller.js": 2483,
	"./glosepus_controller.js": 1846,
	"./highscore_controller.js": 6752,
	"./keyboard_controller.js": 123,
	"./language_controller.js": 3873,
	"./modal_delete_controller.js": 663,
	"./modal_error_controller.js": 9030,
	"./modal_warning_controller.js": 9099,
	"./peek_answer_controller.js": 7408,
	"./qrcode_controller.js": 9902,
	"./reset_score_controller.js": 9528,
	"./share_controller.js": 8343,
	"./share_name_controller.js": 7333,
	"./show_share_controller.js": 5983,
	"./start_button_controller.js": 9751,
	"./table_controller.js": 7546,
	"./tilbake_button_controller.js": 6611,
	"./timer_controller.js": 6631,
	"./toggle_controller.js": 2183,
	"./try_again_controller.js": 1626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3700;